import { render, staticRenderFns } from "./deliveryareabuildingtimeSetting_new.vue?vue&type=template&id=09f65642&scoped=true"
import script from "./deliveryareabuildingtimeSetting_new.vue?vue&type=script&lang=js"
export * from "./deliveryareabuildingtimeSetting_new.vue?vue&type=script&lang=js"
import style0 from "./deliveryareabuildingtimeSetting_new.vue?vue&type=style&index=0&id=09f65642&prod&lang=scss"
import style1 from "./deliveryareabuildingtimeSetting_new.vue?vue&type=style&index=1&id=09f65642&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f65642",
  null
  
)

export default component.exports